<template>
  <div class="wx-login-container">
    <div @click="handleGetWxLoginQRCode">
      <slot></slot>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      :fullscreen="isMobile"
      :custom-class="isMobile ? 'mobile-wx-login-dialog' : 'wx-login-dialog'"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      @close="clearTimer">
      <iframe v-if="qrCodePath" :src="qrCodePath" style="width: 100%; height: 100%; border: none;"></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  emits: ['onGetOpenId'],
  name: 'wxLoginComponent',
  data() {
    return {
      isMobile: this.$TOOL.isMobile,
      qrCodePath: '',
      dialogVisible: false,
      resultTimer: null,
    }
  },
  methods: {
    handleGetWxLoginQRCode() {
      const randCode = this.$TOOL.generateRandomNumber(16)
      this.$API.getWxEr.post({ Type: this.isMobile ? 2 : 1, RandCode: randCode }).then((res) => {
        if (res.error == 0) {
          this.qrCodePath = res.info
          this.dialogVisible = true
          this.handleGetQRCodeResult(randCode)
        } else {
          this.$dialog.alert({
            type: 'danger',
            title: '提示',
            message: res.info,
            confirmButtonText: '确定',
          })
        }
      })
    },
    handleGetQRCodeResult(randCode) {
      this.clearTimer()
      this.resultTimer = setInterval(() => {
        this.$API.checkLogin.post({ RandCode: randCode }).then((res) => {
          if (res.error == 0 && res.info) {
            this.$emit('onGetOpenId', res.info)
            this.dialogVisible = false
            this.clearTimer()
          }
        })
      }, 5000)
    },
    clearTimer() {
      if (this.resultTimer) {
        clearInterval(this.resultTimer)
      }
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.wx-login-dialog {
  max-width: 500px;
  .el-dialog__body {
    height: 450px;
  }
}
/deep/.mobile-wx-login-dialog {
  width: 100%;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    height: calc(100% - 103px);
  }
}
</style>